import React from 'react'
import { Button } from '@/components/ui/button'
import { PaymentProviderThresholdDto } from 'api/PaymentProvider/Types/PaymentProviderThresholdDto'
import {
  FormBaseButtonContainer,
  FormBaseContainer,
  FormBaseErrorMessage,
  FormBaseFieldBlock,
  FormBaseFieldGroup,
  FormBaseFieldLabel,
  FormBaseRow,
} from 'components/Form/Form.styles'
import { Field, Form, FormikErrors, FormikProps, withFormik } from 'formik'
import { FormSubmitValues } from 'utils/formValidation'

import { validateAmount } from './AddWithdrawalThresholdForm'

export interface EditWithdrawalThresholdFormValues {
  id: string
  paymentProviderMethodName: string
  currencyId: string
  bankCode: string
  amount: number
}

const EditWithdrawalThresholdFormUI: React.FC<
  FormikProps<EditWithdrawalThresholdFormValues> & OuterProps
> = (props) => {
  const { handleSubmit, setSubmitting, isSubmitting, errors } = props

  const handleSubmitForm = () => {
    setSubmitting(true)
    handleSubmit()
  }

  return (
    <FormBaseContainer>
      <Form>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Payment Provider</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field type='text' name='paymentProviderMethodName' disabled />
            </FormBaseFieldGroup>
          </FormBaseRow>
        </FormBaseFieldBlock>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Currency</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field type='text' name='currencyId' disabled />
            </FormBaseFieldGroup>
          </FormBaseRow>
        </FormBaseFieldBlock>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Bank Code</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field type='text' name='bankCode' disabled />
            </FormBaseFieldGroup>
          </FormBaseRow>
        </FormBaseFieldBlock>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Amount</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field type='number' name='amount' min='0' step='0.01' />
            </FormBaseFieldGroup>
          </FormBaseRow>
          {errors.amount && <FormBaseErrorMessage>{errors.amount}</FormBaseErrorMessage>}
        </FormBaseFieldBlock>
        <FormBaseButtonContainer>
          <Button disabled={isSubmitting} key='button' onClick={handleSubmitForm} type='button'>
            Update
          </Button>
        </FormBaseButtonContainer>
      </Form>
    </FormBaseContainer>
  )
}

interface OuterProps {
  data: PaymentProviderThresholdDto

  onSubmit(values: FormSubmitValues<EditWithdrawalThresholdFormValues>): Promise<void>
}

export const EditWithdrawalThresholdForm = withFormik<
  OuterProps,
  EditWithdrawalThresholdFormValues
>({
  mapPropsToValues: ({ data }) => {
    return {
      id: data.id,
      paymentProviderMethodName: data.paymentProviderMethod?.name ?? '',
      currencyId: data.currency?.id ?? '',
      bankCode: data.bankCode ?? '',
      amount: data.amount,
    }
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      await props.onSubmit(values)
    } finally {
      setSubmitting(false)
    }
  },
  validate: (values) => {
    const errors: FormikErrors<EditWithdrawalThresholdFormValues> = {}
    const amountError = validateAmount(values.amount)
    if (amountError) {
      errors.amount = amountError
    }
    return errors
  },
  enableReinitialize: true,
})(EditWithdrawalThresholdFormUI)
